export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Vendor\",\n    \"label_other\": \"{{count}} Vendors\"\n}\n"